import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-shopping-chart-bar1-icon',
  templateUrl: './shopping-chart-bar1.component.html'
})
export class ShoppingChartBar1Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
